import { render } from "./stepNavigation.vue?vue&type=template&id=2753dcda&scoped=true"
import script from "./stepNavigation.vue?vue&type=script&lang=js"
export * from "./stepNavigation.vue?vue&type=script&lang=js"

import "./stepNavigation.vue?vue&type=style&index=0&id=2753dcda&scoped=true&lang=css"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2753dcda"]])

export default __exports__